import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Divider, Box, Typography, Grid } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { deleteUser } from '@/actions/user';

import { USER_LOGOUT } from '@/providers/actionTypes';
import { useAuth, useAuthDispatch } from '@/providers/AuthContext';
import { useApi } from '@/providers/ApiContext';

export default function AccountDelete() {
  const navigate = useNavigate();
  const api = useApi();
  const auth = useAuth();
  const auth_dispatch = useAuthDispatch();
  const [loading, setLoading] = useState<boolean>(false);

  const handleDelete = async () => {
    if (!api) return;
    setLoading(true);
    await deleteUser(api);
    auth_dispatch({ type: USER_LOGOUT });
    if (auth.user_manager) {
      await auth.user_manager.signoutRedirect();
    }
    setLoading(false);
    navigate('/');
  };

  return (
    <Box>
      <Grid container spacing={1}>
        <Grid size={12}>
          <Typography variant='h6' color='error'>
            Delete Account
          </Typography>
          <Divider />
        </Grid>
        <Grid size={12}>
          <Typography variant='body1'>
            Deleting your account will permanently clear all data associated
            with your account. This action is not recoverable.
          </Typography>
        </Grid>
        <Grid size={12}>
          <LoadingButton
            loading={loading}
            onClick={handleDelete}
            variant='contained'
            color='error'
          >
            Delete your account
          </LoadingButton>
        </Grid>
      </Grid>
    </Box>
  );
}
